<template>
  <div>
    <Modal v-model="relatedAttributeManageModal" :title="$t('key1000404')" :width="1200" :transfer="false" :mask-closable="false"
      @on-visible-change="relatedAttributeManageChange">
      <div class="operation_box flex align-items-center">
        <!--新增模板-->
        <Button
          type="primary"
          @click="$refs['subAttribute'].initAttributesData('add')"
          class="mr15">
          {{ $t('key1000405') }}
        </Button>
        <!--导入-->
        <Button
          class="mr15"
          type="primary"
          @click="$refs['attributePool'].initAttributePoolData(0, ymsSiteId, ymsProductAttributeTemplateId)"
          v-if="getPermission('ymsProductAttributeTemplate_excelImport')">
          {{ $t('key1000406') }}
        </Button>
      </div>
      <div class="table_box">
        <Table
          highlight-row
          border
          max-height="550"
          :draggable="draggable"
          @on-drag-drop="dragDrop"
          :loading="tableLoading"
          :columns="tableColumns"
          :data="tableData">
        </Table>
      </div>
      <template #footer>
        <Button type="primary" @click="associationPropertyBtn">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
    <!--新增子属性弹窗-->
    <subAttributeModal
      ref="subAttribute"
      :ymsSiteList="ymsSiteList"
      @updateData="updateAssociationProperty">
    </subAttributeModal>
    <!--属性池管理弹窗-->
    <attributePoolModal ref="attributePool" @updateAttributeTableData="updateAttributeTableData"></attributePoolModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import subAttributeModal from "@/components/common/subAttributeModal.vue";
import attributePoolModal from "@/views/yms/components/commodityManage/attributePoolModal.vue";
import {getDataSetBatchList, getEnumName} from "@/utils/common";

export default {
  name: 'relatedAttributeManageModal',
  mixins: [Mixin],
  props: {
    ymsSiteList: {
      type: Array,
      default: () => []
    },
    ymsSiteId: {
      type: String,
      default: null
    },
  },
  data() {
    let v = this;
    return {
      relatedAttributeManageModal: false,
      attributeRequireList: [
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000304')},
        {value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000305')},
        {value: 2, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000306')}
      ],
      isAllowCustomValueList: [
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000392')},
        {value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000393')},
      ],
      chooseTypeList: [
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000394')},
        {value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000395')},
      ],
      isSizeAttributeList: [
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000392')},
        {value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000393')},
      ],
      draggable: false,
      tableData: [],
      tableColumns: [
        {
          title: '',
          key: 'sort',
          align: 'center',
          width: 60,
          renderHeader: (h) => {
            return h('span', '');
          },
          render: (h) => {
            return h('div', {
              class: 'cursor-move',
              on: {
                mousedown() {
                  v.draggable = true;
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-move',
                  size: 18
                },
                class: 'cursor-move'
              })
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000343'),
          key: 'index',
          width: 80,
          align: 'center',
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000396'),
          key: 'cnName',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000397'),
          key: 'type',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let type = params.row.type;
            let text = getEnumName(v.enumData, 'YmsProductAttributeValueTypeCoreEnum', type, 'number');
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000398'),
          key: 'isAllowCustomValue',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let isAllowCustomValue = Number(params.row.isAllowCustomValue);
            let text = '-';
            v.isAllowCustomValueList.map((item) => {
              if (item.value === isAllowCustomValue) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000399'),
          key: 'attributeRequire',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            let attributeRequire = params.row.attributeRequire;
            let text = '';
            v.attributeRequireList.map((item) => {
              if (item.value === attributeRequire) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000400'),
          key: 'chooseType',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            let chooseType = params.row.chooseType;
            let text = '-';
            v.chooseTypeList.map((item) => {
              if (item.value === chooseType) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 300,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: true,
                    clickFn: () => {
                      v.$refs['subAttribute'].initAttributesData('look', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000402'),
                    show: true,
                    color: '#FF0000',
                    clickFn: () => {
                      v.$Modal.confirm({
                        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000403'),
                        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111'),
                        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
                        onOk: () => {
                          v.tableData.splice(params.index, 1);
                        },
                        onCancel: () => {

                        }
                      });
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      relatedAttributeType: null,
      ymsProductAttributeTemplateId: null,
      enumData: [],
    };
  },
  methods: {
    // 初始化数据
    async initRelatedAttributeManageData(type, obj) {
      let enumKeyList = ['YmsProductAttributeValueTypeCoreEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);
      this.relatedAttributeType = type;
      this.ymsProductAttributeTemplateId = obj.ymsProductAttributeTemplateId || null;
      let ymsProductAttributeDictionaryRelationBos = obj.ymsProductAttributeDictionaryRelationBos || [];
      if (type !== 'add') {
        if (ymsProductAttributeDictionaryRelationBos.length <= 0) {
          this.axios.get(api.get_ymsProductAttributeTemplate_getRelateTemplates + obj.ymsProductAttributeDictionaryId,
            null, {loading: true}).then((response) => {
            if (response.data.code === 0) {
              let list = response.data.datas || [];
              let newList = list.filter((item) => item.status === 1);
              newList.map((item, index) => {
                item.sortNo = index + 1;
              });
              this.tableData = newList;
            }
          });
        } else {
          let ymsProductAttributeTemplateIds = ymsProductAttributeDictionaryRelationBos.map((item) => {
            return item.ymsProductAttributeTemplateId;
          });
          this.getBatchAttrValue(ymsProductAttributeTemplateIds);
        }
      } else {
        if (ymsProductAttributeDictionaryRelationBos.length <= 0) {
          this.tableData = [];
        } else {
          let ymsProductAttributeTemplateIds = ymsProductAttributeDictionaryRelationBos.map((item) => {
            return item.ymsProductAttributeTemplateId;
          });
          this.getBatchAttrValue(ymsProductAttributeTemplateIds);
        }
      }
      this.relatedAttributeManageModal = true;
    },
    // 更新
    updateAssociationProperty(obj) {
      let list = [obj.ymsProductAttributeTemplateId];
      this.tableData.map((item) => {
        if (item.ymsProductAttributeTemplateId) {
          list.push(item.ymsProductAttributeTemplateId);
        }
      });
      let newList = this.uniqueFunc(list);
      this.getBatchAttrValue(newList);
    },
    // 属性池选择
    updateAttributeTableData(data) {
      let list = [];
      data.map((item) => {
        if (item.ymsProductAttributeTemplateId) {
          list.push(item.ymsProductAttributeTemplateId);
        }
      });
      this.tableData.map((item) => {
        if (item.ymsProductAttributeTemplateId) {
          list.push(item.ymsProductAttributeTemplateId);
        }
      });
      let newList = this.uniqueFunc(list);
      this.getBatchAttrValue(newList);
    },
    // 批量查询属性
    getBatchAttrValue(ymsProductAttributeTemplateIds) {
      let v = this;
      if (ymsProductAttributeTemplateIds.length > 0) {
        v.tableData = [];
        v.axios.post(api.post_ymsProductAttributeTemplate_queryByTemplateIds, ymsProductAttributeTemplateIds).then((response) => {
          if (response.data.code === 0) {
            let list = response.data.datas || [];
            let newList = list.filter((item) => item.status === 1);
            newList.map((item, index) => {
              item.sortNo = index + 1;
            });
            v.tableData = newList;
          }
        });
      }
    },
    // 监听弹窗
    relatedAttributeManageChange(value) {
      if (!value) {

      }
    },
    // 拖拽排序
    dragDrop(oldIndex, newIndex) {
      let v = this;
      v.tableData[oldIndex] = v.tableData.splice(newIndex, 1, v.tableData[oldIndex])[0];
      v.tableData.map((item, index) => {
        item.sortNo = index + 1;
      });
      v.draggable = false;
      v.$forceUpdate();
    },
    // 确定
    associationPropertyBtn() {
      let list = [];
      if (this.tableData.length > 0) {
        list = this.tableData.map((item) => {
          return {
            ymsProductAttributeTemplateId: item.ymsProductAttributeTemplateId,
            sortNo: item.sortNo
          };
        });
      }
      this.$emit('updateRelatedAttribute', list);
      this.relatedAttributeManageModal = false;
    },
  },
  components: {
    attributePoolModal,
    subAttributeModal
  },
};
</script>

<style lang="less">

</style>
